import { Chip, Theme, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { AgencyCode, AreaCode, RegionCode } from "../../../reducers/states/agency";
import { GetAgency } from "../../../reducers/states/agency/agencies";
import { getWspLabel } from "../../../reducers/states/agency/wsp";

const useStyles = makeStyles((theme: Theme) => ({
  chipWSP: {
    backgroundColor: theme.agency.WSP,
    color: "white",
  },
  chipKCM: {
    backgroundColor: theme.agency.KCM,
    color: "white",
  },
  chipSFD: {
    backgroundColor: theme.agency.SFD,
    color: "white",
  },
  chipSPD: {
    backgroundColor: theme.agency.SPD,
    color: "white",
  },
  chipNeutral: {
    backgroundColor: theme.agency.Neutral,
    color: "black",
  },
  chipClosed: {
    backgroundColor: theme.marker.ClosedDispatchEventIFD,
    color: "white",
  },
  listItem: {
    flex: "1 1 55%",
  },
  removeButton: {
    color: theme.agency.SFD,
    padding: "3px",
    "margin-left": "10px",
  },
}));

interface ChipProps {
  props: {
    agency: AgencyCode;
    area?: AreaCode;
    region?: RegionCode;
    isClosed?: boolean;
  };
}

export const AgencyChip = ({ props }: ChipProps) => {
  const classes = useStyles();

  const createChip = (label: string, className: string, tooltip?: string) => {
    return (
      <Tooltip title={tooltip}>
        <Chip label={label} className={props.isClosed ? classes.chipClosed : className} sx={{ minWidth: "54px" }}/>
      </Tooltip>
    )
  }

  if (props.agency === "") {
    return <div>{props.agency}</div>;
  }

  const agencyName = GetAgency(props.agency)?.name || props.agency;
  switch (props.agency) {
    case AgencyCode.WSP:
      return createChip(AgencyCode.WSP, classes.chipWSP, `${agencyName}, ${(getWspLabel(props.area) as string)}`);
    case AgencyCode.KCM:
      return createChip(AgencyCode.KCM, classes.chipKCM, agencyName);
    case AgencyCode.SFD:
      return createChip(AgencyCode.SFD, classes.chipSFD, agencyName);
    case AgencyCode.SPD:
      return createChip(AgencyCode.SPD, classes.chipSPD, agencyName);
    default:
      return createChip(agencyName, classes.chipNeutral);
  }
};
